import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_program_cc_endpoint_link_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    program_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cc_endpoint_guid: fromDatatype.GuidDataFieldInterface;
    priority:fromDatatype.IntegerDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeClass;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_mlm_program_cc_endpoint_link_RowClass implements bl_mlm_program_cc_endpoint_link_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    program_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cc_endpoint_guid: fromDatatype.GuidDataFieldInterface;
    priority:fromDatatype.IntegerDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeClass;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}